<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow elevation-8 pb-5">
          <v-card-title primary-title>
            <div class="text-h5">Impostazioni WhatsApp </div>
            <v-spacer></v-spacer>
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon  fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </div>           
          </v-card-title>
          <v-row v-if="loading">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
          </v-row>
          
          <v-row v-else class="mx-5">
            <v-col cols="12">
              <v-divider></v-divider>              
            </v-col>
            <v-col cols="12" xl="8" class="order-0 order-xl-1">
              <v-card class="neu-glow">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Testi Personalizzabili nei Messaggi WhatsApp
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-8" :loading="loading_update" :disabled="templates_hash===JSON.stringify(templates)" @click.stop="saveTemplate()">
                        <v-icon color="error">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>Salva</span>
                  </v-tooltip>                  
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" @click="dialog_vuecropper=true" >
                        <v-icon color="info">mdi-image-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Cambia Immagine</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="restoreImage()">
                        <v-icon color="warning">mdi-image-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>Ripristina Immagine</span>
                  </v-tooltip>                           
                </v-card-title>
                <v-card-text>
                  <v-row class="mt-3 ml-2">
                    <v-col cols="4" class="mt-n7">          
                      <v-radio-group
                        v-model="selectedTemplate"
                        column   
                      >
                        <template v-for="(t,ti) in templates">
                          <v-radio
                            v-if="t.templateId"
                            :key="ti"
                            :label="t.templateName"
                            color="info"
                            :value="t"
                          ></v-radio>
                          <v-divider v-else class="py-1" :key="ti"></v-divider>
                        </template>
                      </v-radio-group>           
                    </v-col>
                    <v-col cols="4">
                      <template v-if="selectedTemplate">
                        <template v-for="(f,fi) in selectedTemplate.flds">
                          <v-textarea
                            :class="fi>0?'mt-2':''"
                            v-if="f.type=='textarea'"                          
                            :key="fi"
                            outlined
                            :label="f.hint"
                            v-model="inputFields[fi]"
                            :hint="'Es: '+f.suggestedText"
                            persistent-hint
                            persistent-placeholder
                          >
                          </v-textarea>                          
                          <v-text-field
                            v-else
                            :class="fi>0?'mt-2':''"                          
                            :key="fi"
                            outlined
                            :label="f.hint"
                            v-model="inputFields[fi]"
                            :hint="'Es: '+f.suggestedText"
                            persistent-hint
                            persistent-placeholder
                          >
                          </v-text-field>
                      </template>
                      <v-alert
                        v-if="selectedTemplate.flds"
                        dense
                        type="error"
                      >
                        Le regole di WhatsApp non consentono di inserire <strong>"a capo"</strong> (return/invio) nei testi liberi: se presenti verranno sostituiti da uno spazio.
                      </v-alert>
                    </v-col>
                    <v-col cols="4" class="pl-3">
                      <v-card class="px-5 mb-8 neu-glow-inset" style="max-width: 350px;margin: auto;">
                        <v-row v-if="selectedTemplate">
                          <v-col class="text-body-1">
                            <template v-for="(r,ri) in selectedTemplate.rows">
                              <template v-if="r.footer">
                                <p class="text-caption"  :key="ri">
                                  <span v-html="r.rowValue"></span>
                              </template>
                              <template v-else-if="r.brand">
                              <p class="text-subtitle-1 mb-0 mt-n3 font-weight-black" :key="ri">{{brand}}</p>
                              </template>
                              <template v-else-if="r.button">
                                <v-btn
                                  v-if="r.rowValue"
                                  :small="r.smallButton"
                                  outlined
                                  block
                                  :key="ri"
                                  class="ma-1"
                                  color="info"             
                                >
                                  <span v-html="r.rowValue"></span>
                                </v-btn>                              
                              </template>
                              <template v-else-if="r.link">
                                <v-btn
                                  outlined
                                  block
                                  :key="ri"
                                  class="ma-1"
                                  color="info"             
                                >
                                  <v-icon class="mr-2">mdi-open-in-new</v-icon>
                                  <span v-html="r.rowValue"></span>
                                </v-btn>
                              </template>
                              <template v-else-if="r.rowValue==''">
                                <!--<p class="mt-n5 mb-0" :key="ri" />-->
                              </template>
                              <template v-else-if="r.rowValue=='Logo'">
                                <v-img class="transparent mb-3" style="background-color:#000" :key="ri" :src="'https://ibookrestaurant.com/static/users/pictures/wa/'+pictureName" />
                              </template>                              
                              <template v-else-if="r.editable">
                                <p class="text-subtitle-1 mb-2 red--text"  :key="ri">
                                  <span v-html="replacedMsg(r)"></span>
                                </p>
                              </template> 
                              <template v-else>
                                <p class="text-subtitle-1 mb-2"  :key="ri">
                                  <span v-html="replacedMsg(r)"></span>
                                </p>
                              </template>      
                            </template>
                          </v-col>
                        </v-row>
                      </v-card>      
                    </v-col>
                  </v-row> 
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" xl="4" class="order-1 order-xl-0">
              <v-card class="neu-glow" :class="$vuetify.breakpoint.xlAndUp?' mb-3':' mb-3'">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Parametri Promemoria Prenotazioni/Recensione
                </v-card-title>
                <template v-if="WA_Options">
                  <v-row class="mx-2" v-for="(i,ii) in WA_Options.filter(w=>w.optionId!=='logoWA'&&w.optionId!=='logoWAW')" :key="ii">
                    <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">
                        <v-text-field   
                          dense
                          counter
                          :label="i.description"
                          :name="i.optionId"
                          outlined
                          :reverse="i.dataType!='nvarchar'"
                          v-model="i.value"
                          persistent-placeholder
                          hide-details
                          @input.native="save"
                          :readonly="!i.editableByUser"
                        >
                        </v-text-field>
                    </v-col>
                    <template v-else>
                      <v-col cols="6" class="d-flex align-center">
                        {{i.description}}
                      </v-col>
                      <v-col cols="5" class="d-flex align-center">
                        <template v-if="i.dataType=='bit'">
                          <v-switch
                            color="info"
                            dense
                            v-model="i.value"
                            inset
                            :name="i.optionId"
                            :label="i.value=='1'?'Si':'No'"
                            hide-details
                            :readonly="!i.editableByUser"
                            @change="save2($event, i.optionId,'User_Options')"
                            class="mt-0 pt-0"
                          ></v-switch>                      
                        </template>
                        <template v-else>
                          <v-text-field   
                            dense
                            counter
                            label=""
                            outlined
                            :name="i.optionId"
                            type="number"
                            :reverse="i.dataType!='nvarchar'"
                            v-model="i.value"
                            persistent-placeholder
                            @input.native="save"
                            hide-details
                            :readonly="!i.editableByUser"
                          >
                          </v-text-field>                          
                        </template>
                      </v-col>
                    <v-col cols="1" class="d-flex align-center">
                      <v-tooltip max-width="250" top :disabled="!i.help&&!i.editableByUser" v-if="i.help">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                        </template>
                        <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                      </v-tooltip>                          
                    </v-col>                                                
                  </v-row>
                </template>
              </v-card>
            </v-col>
            <v-col cols="6" xl="4" class="order-2 order-xl-2">
              <v-card class="neu-glow">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Impostazioni invii Automatizzati
                </v-card-title>                
                <v-tabs
                  class="blue-grey"
                  v-model="dowId"
                  next-icon="mdi-arrow-right-bold-box-outline"
                  prev-icon="mdi-arrow-left-bold-box-outline"
                  show-arrows
                >
                  <v-tabs-slider color="info"></v-tabs-slider>
                  <template v-for="(d,di) in dows" >
                    <v-tab
                      :key=di
                      value="di"
                      :href="'#'+d"
                      class="font-weight-bold"
                    >
                      {{d}}
                    </v-tab>
                    <v-tab-item :key=d :id="d" class="mb-1 neu-glow">

                      <v-row class="my-n2 pl-5">
                        <v-col cols="12">
                          <v-sheet class="neu-glow">
                            <v-tabs
                              class="grey lighten-5 neu-glow"
                              v-model="mealId"
                              next-icon="mdi-arrow-right-bold-box-outline"
                              prev-icon="mdi-arrow-left-bold-box-outline"
                              show-arrows
                            >
                              <v-tabs-slider color="info"></v-tabs-slider>
                              <template v-for="(m,mi) in allMeals" >
                                <v-tab
                                  :key=mi
                                  :href="'#'+m.mealId"
                                  class="font-weight-bold mr-3 neu-glow"
                                  
                                >
                                  {{m.name}} 
                                </v-tab>
                                <v-tab-item :key=m :id="m.mealId" class="my-3 pl-5 mr-3 neu-glow mt-2" >
                                    <v-row>
                                      <v-col cols="2" style="max-width:100px">
                                        Slot
                                      </v-col>
                                      <v-col v-for="(hh,hi) in headers" :key="hi">
                                        <v-tooltip top>
                                          <template v-slot:activator="{ on, attrs }">
                                            <div v-bind="attrs" v-on="on" class="text-center">
                                              {{hh.title}}
                                            </div>
                                          </template>
                                          <span v-html="hh.remarks"></span>
                                        </v-tooltip>
                                      </v-col>
                                    </v-row>
                                    <template v-for="(s,si) in activeSlots.filter(s => s.DOW==di+1&&s.mealId==m.mealId)">
                                      <v-row :key="si" class="px-3" >
                                        <v-col cols="2" style="max-width:100px;min-width:100px" class="text-center">
                                          <v-text-field
                                            label=""
                                            v-model="s.slotName"
                                            name="slot"
                                            outlined
                                            readonly
                                            dense
                                            reverse
                                            hide-details="false"
                                          ></v-text-field>
                                        </v-col>
                                        <v-col class="d-flex justify-center">
                                          <v-checkbox
                                            class="mt-0 pt-2"
                                            dense
                                            v-model="s.reminder"
                                            :id="s.slotId"
                                            @click="save2(s.reminder,'reminder','PBD',s.slotId,$event)"
                                            label=""
                                            hide-details
                                          ></v-checkbox> 
                                        </v-col>
                                        <v-col class="d-flex justify-center">
                                          <v-checkbox
                                            class="mt-0 pt-2"
                                            dense
                                            v-model="s.reviewRequest"
                                            :id="s.slotId"
                                            @click="save2(s.reviewRequest,'reviewRequest','PBD',s.slotId,$event)"
                                            label=""
                                            hide-details
                                          ></v-checkbox> 
                                        </v-col>
                                        <!--   
                                        <v-col class="d-flex justify-center">
                                          <v-checkbox
                                            class="mt-0 pt-2"
                                            dense
                                            v-model="s.manualConfirmation"
                                            :id="s.slotId"
                                            @click="save2(s.manualConfirmation,'manualConfirmation','PBD',s.slotId,$event)"
                                            label=""
                                            hide-details
                                          ></v-checkbox>
                                        </v-col>
                                        -->
                                        
                                      </v-row>
                                    </template>
                                </v-tab-item>
                              </template>
                            </v-tabs>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </template>
                </v-tabs>
              </v-card>              
            </v-col>                    
          </v-row>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              WhatsApp: Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-0">
                <v-col md="12" cols="12">
                    <p>
                      l'Hostname è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni ma anche il punto di ingresso all'App:
                    <br />
                      come default utilizza il nome del vostro sito (o il nome del vostro locale) che avete indicato in fase di registrazione: qualora non sia stato fornito utilizza una stringa casuale (che può comunque essere modificata<sup>1</sup> da questa pagina):
                    </p>
                    <p>
                      Ipotizziamo ad esempio, che il vostro locale si chiami <strong>Arcadia</strong> e/o il vostro sito sia <strong>www.arcadia.it</strong>, il sistema vi attribuirà di default il seguente hostname: <strong>arcadia.jslab.it</strong>
                    </p>
                    <p>
                      E' disponibile, a fronte di un contributo di configurazione una tantum di 100 €, una soluzione del tipo <strong>booking.arcadia.it</strong> (o <strong>qualsiasicosa.arcadia.it</strong>)
                    </p>
                    <p>In quest caso è necessario che:
                      <ul>
                        <li>
                          Creiate un nuovo hostname e lo denominiate come meglio credete, nell'esempio <strong>booking.arcadia.it</strong>
                        </li>
                        <li>
                          Se non avete già un sito, lo registriamo noi a Vostro nome<sup>2</sup>
                          Se invece avete già un sito, inseriate il recapito di colui che gestisce il nome a dominio <strong>arcadia.it</strong> che contatteremo per le necessarie modifiche.
                          <br />In pratica gli chiederemo di creare il sottodominio <strong>booking</strong> e farlo puntare all'indirizzo <strong>84.247.8.202</strong>.
                          <br />(Più tecnicamente creare il seguente DNS Record: <strong>booking 60 IN A 84.247.8.202</strong>)
                        </li>  
                      </ul>
                    <p>
                      Non appena le impostazioni si saranno propagate (il tempo canonico è 24 ore) provvederemo ad apportare le necessarie modifiche di configurazione e l'indirizzo sarà attivo
                    </p>
                    <p>
                      <sup>1</sup>Se non è già utilizzato
                      <sup>2</sup>(dall'anno successivo vi verrà addebitato un canone di 30.00€)
                      </p>
                </v-col>
            </v-row>

        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_vuecropper" max-width="1100">
      <vuecropper 
        v-if="WA_Options"
        @close="closeCropper"
        @completed="handleCompleted"
        @error="handlerError"
        :uploadFormData="UFD"
      >
      </vuecropper>
    </v-dialog>	
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import AvatarCropper from "../AvatarCropper";
import vuecropper from "../VueCropper";
import _ from 'lodash'
export default {
  components: { vuecropper },
  data() {
    return {
      page: "Settings",
      form:{},
      snackbar:false,
      snackbar_color:null,
      snackbar_message:null,
      loading:false,
      loading_update:false,
      loading_refresh:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_edit:false,
      dialog_instruction:false,
	    dialog_vuecropper:false,
      allLocations:null,
      allMeals:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      templates_hash:null,
      templates:null,
      activeField:null,
      editedItem:{},
      uploadURL:'https://ibookrestaurant.com/ajax/settings/upload.php',
      outputOptions:{
        width: 400,
        height: 200,
        minWidth: 400,
        minHeight: 200,
        maxWidth: 400,
        maxHeight: 200,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      },
      pictureName:null,
      pictureNameRoot:null,
      changedLogo:false,
      cropperOptions:{aspectRatio: 2, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false},
      logo_2:'/static/logos/empty_400_182.png',
      selectedTemplate:null,
      brand:null,
      subdomain:null,
      otherOptions:{},
      inputFields:[],
      default:{"fullName":"Mario Rossi","day":"Sabato 19 Agosto","time":"20:30","guests":"5+1 Seggiolone","brand":this.brand,"phone":"3201234567","remarks":"Sotto i Portici","status":"IN LISTA","old_guests":2,"old_children":"0","old_time":"19:30","old_day":"Sabato 26 Luglio","old_area":"esterna"},
      WA_Options:null,
      dows:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headers:[
              {title:"Invio Promemoria",remarks:"Invio Promemoria (solo se Invio Promemoria è attivo nella finestra sopra)"},
              {title:"Invio Richesta Review",remarks:"Invio Richesta Review (solo se Invio Richiesta Review è attivo nella finestra sopra)"},
              /*        
              {title:"Max Coperti",remarks:"Max Coperti accettabili in quello slot"},
              {title:"Max da 1",remarks:"Max Prenotazioni da 1 Coperto"},
              {title:"Max da 2",remarks:"Max Prenotazioni da 2 Coperto"},
              {title:"Max da 3",remarks:"Max Prenotazioni da 3 Coperto"},
              {title:"Durata Pasto",remarks:"Durata Pranzo in Minuti<br>Ovvero entro quanto deve essere lasciato libero il tavolo"},
              {title:"Blocca Prec",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot precedente non ha almeno la percentuale di completezza indicata"},
              {title:"Blocca Succ",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot successivo non ha almeno la percentuale di completezza indicata"},
              {title:"Cauzione",remarks:"Cauzione richiesta (per ogni coperto) per confermare la prenotazione"},
              {title:"Chiusura DB",remarks:"Non accetta prenotazioni da Direct Booking (per lo stesso giorno) oltre l'ora indicata"},
              {title:"Rich FBack",remarks:"Invia richiesta di feedback su queste prenotazioni"}
              */
              ],                          
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    UFD()
    {
      let option=this.WA_Options.find(o=>o.optionId=='logoWA');
      let ufd={'name':option.value,'type':'wa','subdomain':this.subdomain,'optionId':'logoWA','width':option.size.split('x')[0],'height':option.size.split('x')[1]}
      return ufd;
    }	
  },
  created(){
    this.getData();
    this.getData2();
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    selectedTemplate (newValue) {
      console.log(368,newValue,this.WA_Options.find(o=>o.optionId=='logoWA').value);
      this.pictureName=this.WA_Options.find(o=>o.optionId=='logoWA').value;
      this.pictureNameRoot=this.pictureName.split('-')[1];
      this.inputFields=newValue.flds?newValue.flds.map(m=>m.actualValue):[];
      this.templates_hash=JSON.stringify(newValue)
      console.log(375,newValue,this.pictureName);
    },       
  },
  methods:
  {
    closeCropper()
    {
      this.dialog_vuecropper=false;
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificato Logo';
        this.pictureName=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },   
    save: _.debounce(function (event) {
      console.log(400,event.target.name,event.target.value)
      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var pload={"optionId":event.target.name,"value":value};
 
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field, table,slotId='') {
      console.log(410,value, field);
      var pload;     
      if (table=='PBD')
      {
        var dow=this.dows.findIndex(d=>d==this.dowId)+1
        pload={"parameter":field,"value":value===false?0:value===true?1:value===''?null:value,"slotId":slotId,"dow":dow};
        table='AllParametersByDOW_single'
      }
      else
      {
        pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      }
      
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":table,"payload":pload};
      console.log(413,payload)
      let rspns=this.updateDB(payload)
      console.log(rspns)

    },
    async restoreImage()
    {
        this.loading_update=true;
        var action='saveItem';
        var pload={"optionId":"logoWA"};
        let payload={"action":action,"table":"User_Options_Restore","payload":pload};
        console.log(413,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(416,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            console.log(422,w.payloads.ivalue)
             this.pictureName=w.payloads.ivalue
            //this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }         
      //this.pictureName=this.WA_Options.find(o=>o.optionId=='logoWA').value;
      //this.changedLogo=false;
    },
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificato Logo';
        this.pictureName=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },
    replacedMsg(r)
    {
      console.log(565,r,this.default)
      var z= r.rowValue.replace('||fullName||',this.default['fullName']||'')
                       .replace('||day||',this.default['day']||'')
                       .replace('||time||',this.default['time']||'')
                       .replace('||guests||',this.default['guests']||'')
                       .replace('||brand||',this.brand||'')
                       .replace('||status||',this.default['status']||'')
                       .replace('||phone||',this.default['phone']||'')
                       .replace('||remarks||',this.default['remarks']||'')
                       .replace('||old_guests||',this.default['old_guests']||'')
                       .replace('||old_children||',this.default['old_children']||'')
                       .replace('||old_time||',this.default['old_time']||'')
                       .replace('||old_day||',this.default['old_day']||'')
                       .replace('||old_area||',this.default['old_area']||'')
                       //La tua Prenotazione per ||old_guests|| + ||old_children|| coperti alle ||old_time|| di ||old_day|| in ||old_area|| è <strong>Confermata</strong>


      var k=z.replace('##0##',this.inputFields[0]||'')
                  .replace('##1##',this.inputFields[1]||'')
                  .replace('##2##',this.inputFields[2]||'')
                  .replace('##3##',this.inputFields[3]||'')
                  .replace('##4##',this.inputFields[4]||'')
                  .replace('##5##',this.inputFields[5]||'')
                  .replace('##6##',this.inputFields[6]||'')
      return k;
    },
    editItem(f)
    {
      if (f)
      {
        this.editedItem=f
      }
      else
      {
        this.editedItem={};
        this.editedItem_hash=JSON.stringify(this.editedItem)
      }
      console.log(214,f,this.editedItem)
      this.dialog_edit=true;
    }, 
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_edit=true;
    },
    async saveOption()
    {
        console.log(485,JSON.stringify(this.inputFields),this.pictureName)
        var t=this.selectedTemplate.rows.filter(r=>r.editable).map(m=>m.tmpId)
        console.log(t)
        var pload = t.map((id, index) => {return {key: id,value: this.inputFields[index]}});
        //const pload = t.reduce((obj, key, index) => ({ ...obj, [key]: inputFields[index] }), {});
        console.log(490,pload)
        if(this.changedLogo)
        {
          pload[0].pictureName=this.pictureName;
        }
        this.loading_update=true;
        var action='saveItem';
        let payload={"action":action,"table":"WhatsAppMessagesTemplates","payload":pload};
        console.log(498,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(501,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    }, 
    async saveTemplate()
    {
        console.log(513,this.selectedTemplate,this.pictureName);
        console.log(514,JSON.stringify(this.inputFields))
        var t=this.selectedTemplate.rows.filter(r=>r.editable).map(m=>m.tmpId)
        console.log(516,t)
        var pload = t.map((id, index) => {return {key: id,value: this.inputFields[index]}});
        //const pload = t.reduce((obj, key, index) => ({ ...obj, [key]: inputFields[index] }), {});
        console.log(519,pload)
        if(this.changedLogo)
        {
          pload[0].pictureName=this.pictureName;
        }
        this.loading_update=true;
        var action='saveItem';
        let payload={"action":action,"table":"WhatsAppMessagesTemplates","payload":pload};
        console.log(527,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(530,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    }, 
    async getData2()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(282,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllWhatsAppMessagesTemplates_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.WA_Options=res.data.payloads.WA_Options.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                      //this.WA_Options=res.data.payloads.WA_Options;
                      //this.otherOptions={...res.data.payloads.WA_Options.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o})};
                      this.templates=res.data.payloads.WA_Templates;
                      this.brand=res.data.payloads.WA_Brand.brand;
                      this.subdomain=res.data.payloads.WA_Subdomain.subdomain;
                      this.templates_hash=JSON.stringify(this.templates);
                      console.log(315,this.templates,this.brand,this.WA_Options,this.WA_Options.find(o=>o.optionId=='logoWA').value,this.otherOptions)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
            } catch(e)
            {
                this.loading= false;
                this.loading_refresh=false;
                this.dialog_connection_error=true;
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style scoped>
	._wa_text {
		color: #282828;
		font-size: 13.6px;
		white-space: pre-wrap;	
		word-wrap: break-word;
		font-family: Arial, sans-serif;
	}
	._wa_caption {
		color: rgba(0, 0, 0, .45);
		font-size: 13px;
		line-height: 17px;
		font-family: Arial, sans-serif;
		padding: 0 7px 8px 9px;
	}
	
	._wa_buttons {
		background-color: #fff;
		border-radius: 7.5px;
		box-shadow: 0 1px 0.5px rgba(0, 0, 0, .15);
		box-sizing: border-box;
		flex-grow: 1;
		margin: 2px 0 0 2px;
		font-family: Arial, sans-serif;
		min-width: calc(50% - 2px);
	}
	
	._wa_time {
		bottom: 3px;
		color: rgba(0, 0, 0, .4);
		font-size: 11px;
		height: 15px;
		line-height: 15px;
		position: absolute;
		right: 7px;
		font-family: Arial, sans-serif;
	}
</style>